/** ----------------------------------------
     State
 ---------------------------------------- */

const state = () => {
    return {
        data: [
            {
                active: true,
                id: 1,
                slug: 'digital',
                subtitle: 'Our Services',
                title: 'Digital Development',
                text: 'Only on a solid strategic foundation, one can start building. Therefore, our Dutch Digital Design is grounded in a strategic process. Whether it is about the brand, marketing, content, social media or user experience, we research the brand/product thoroughly and provide strategic guidelines to help communicate in better ways.',
                image: {
                    src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/thumbs/1440x_5cdd74d958a0b66cb6df1ca63cec7d0b35e1c711f335f.jpg',
                },
                contact: 'Sander Hidding',
                blocks: [
                    {
                        type: 'text',
                        options: {
                            position: 'left',
                            size: 'small',
                        },
                        content: {
                            title: 'We help you identify and reach your goal',
                            text: 'We believe the digital world becomes a better place when design-driven solutions are provided. We adapt our services to your needs and are engaged sparring partners in the process. Together, we can build the best solutions to conquer overarching challenges. Like we did for Dutch Design Week, Miro and Theater Rotterdam.'
                        }
                    },
                    {
                        type: 'image',
                        options: {
                            alt: '',
                            size: 'large',
                        },
                        content: {
                            src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/uploads/5c87baa0be3b527b69c8c2157697993874a430f62c049.jpg',
                        }
                    },
                    {
                        type: 'text',
                        options: {
                            size: 'small',
                        },
                        content: {
                            title: 'Miro, for modern-day pioneers',
                            text: 'Rebranding an already loved and daily used platform like Miro doesn’t work without the input of its trailblazing users. We did extensive user research on online user behavior on the platform itself and questioned stakeholders and power users across the world to capture the building blocks and essential elements of the brand. <br><br> Power users described Miro as a solution for collaborating in a distributed, digital way with teams across the world. Also, they loved the supportive character of the Miro team. We took these characteristics and put them at the core of the new brand story of Miro. Besides being supportive, Miro also challenges its users to get on the same page by using the same professional language. In different strategic sessions, we transformed all insights into a clear strategic brand story that lays the foundation of the new brand platform and identity.'
                        }
                    },
                    {
                        type: 'cases',
                        content: {
                            cases: [
                                'Miro',
                                'Dutch Design Week'
                            ]
                        }
                    },
                    {
                        type: 'text',
                        options: {
                            size: 'small',
                        },
                        content: {
                            title: 'Miro, for modern-day pioneers',
                            text: 'Rebranding an already loved and daily used platform like Miro doesn’t work without the input of its trailblazing users. We did extensive user research on online user behavior on the platform itself and questioned stakeholders and power users across the world to capture the building blocks and essential elements of the brand. <br><br> Power users described Miro as a solution for collaborating in a distributed, digital way with teams across the world. Also, they loved the supportive character of the Miro team. We took these characteristics and put them at the core of the new brand story of Miro. Besides being supportive, Miro also challenges its users to get on the same page by using the same professional language. In different strategic sessions, we transformed all insights into a clear strategic brand story that lays the foundation of the new brand platform and identity.'
                        }
                    }
                ]
            },
            {
                active: true,
                id: 2,
                slug: 'strategy',
                subtitle: 'Our Services',
                title: 'Strategy',
                text: '',
                images: {
                    src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/thumbs/1440x_5cdd74d958a0b66cb6df1ca63cec7d0b35e1c711f335f.jpg'
                },
                contact: 'Yira Rodriguez Garcia',
            },
            {
                active: true,
                id: 3,
                slug: 'design',
                subtitle: 'Our Services',
                title: 'Design',
                text: '',
                images: {
                    src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/thumbs/1440x_5cdd74d958a0b66cb6df1ca63cec7d0b35e1c711f335f.jpg'
                },
                contact: 'Walewijn den Boer',
            }
        ]
    }
};

/** ----------------------------------------
    Export State
 ---------------------------------------- */

export default state;